<section>
  <div *ngIf="visibleListDetail" class="container-style">
    <p class="quantity-details mt-0" [hidden]="detailData.totalItems === 0">
      {{detailData.totalItems}} bodegas agregada(s) de 100 permitidas.</p>
    <app-custom-table [headers]="detailHeader" [data]="detailData" [checkBoxAction]="checkboxActions"
      [clearSelectionTrigger]="clearSelectionTrigger" [showCheckbox]="rowsEditable()" [showRecover]="true"
      (onFilterChange)="onFilterChange($event)" (onRecoverData)="getSubrentalCutoffDetailsForRegisterTable()"
      (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</section>